import { render } from "./PairScanButton.vue?vue&type=template&id=657a54d1"
import script from "./PairScanButton.vue?vue&type=script&lang=ts"
export * from "./PairScanButton.vue?vue&type=script&lang=ts"
script.render = render

export default script